export default __webpack_public_path__ + "static/media/chevronRight.11ac5ea3.svg";